import { FunctionComponent, ReactNode } from "react";

type HeaderTextType = {
  header?: string;
  headerTwo?: string;
  qoute?: string | ReactNode;
  img?: string;
  customWidth?: string;
};

const SubHeaderText: FunctionComponent<HeaderTextType> = ({
  header,
  headerTwo,
  qoute,
  img,
  customWidth = "w-[11%] text-center"
}) => {
  return (
    <div className="">
      <div className="flex justify-center flex-col">
        <h1 className="relative text-[1.6vw] max-md:text-[16px] text-center text-white m-0 p-0">
          {header}
        </h1>
        { headerTwo ?
          <b className="relative pt-6 max-md:pt-5 text-3xl max-md:text-[16px] text-center text-white font-os">
          {headerTwo} 
        </b> : <></>
        }
      </div>
      <div className="flex max-md:flex-col text-white font-os relative justify-center max-md:pt-5 pt-12">
        {
          headerTwo ?
            <>
              <img className="max-md:hidden max-md:w-6/12 max-md:mx-auto w-4/12 ml-[22vw] max-h-[20rem]" src={img} loading="lazy" alt="" />
              <div className={customWidth + " relative pt-[2vh] max-md:pt-12 max-md:bottom-10 max-md:text-[14px] text-[1vw] pl-[10vw] max-md:w-10/12 font-os"}>
                <i>
                  {qoute}
                </i>
              </div>
            </>
            :
            <>
              <img className="max-md:w-6/12 w-5/12 max-md:h-24 max-md:mx-auto ml-[20vw] max-h-[28rem]" src={img} loading="lazy" alt="" />
              <div className={customWidth +" relative pt-[19vh] max-md:pt-14 max-md:bottom-10 max-md:text-[14px] text-[1vw] pl-[10vw] max-md:w-10/12 font-os"}>
                <i>
                  {qoute}
                </i>
              </div>
            </>
        }
      </div>
    </div>
  );
};

export default SubHeaderText;
